import React from 'react';
import { EcardContainer, EcardWrapper } from './Ecard.styles';
import globalWindow from '@shared/core/globals';
import { useRouterHelper } from '@shared/core';
import { AdminHeaderBar, AdminHeaderBarSpacer } from '@apps/admin/components/AdminHeaderBar';
import { useFeatureValue } from '@shared/core/featureFlags';
import { useNativeState } from '@shared/core/native';
import { useResponsive } from '@shared/utils/hooks/useResponsive';
import { getEcardTypeDisplayName } from './Ecard.utils';
import type { EcardType } from '@graphql/generated';
import Header from '@shared/components/EmailsAndEcards/components/Header';
import { withWindow } from '@shared/utils/withWindow';

type EcardProps = Readonly<{
  ecardDraftType: EcardType;
}>;

export const Ecard: React.FC<EcardProps> = ({ children, ecardDraftType }) => {
  if (globalWindow.Intercom) {
    globalWindow.Intercom('update', { hide_default_launcher: true });
  }
  const routerHelper = useRouterHelper();
  const { isNative } = useNativeState();
  const [isMobile] = useResponsive({ values: { mobile: true, tablet: false } });
  const { value: adminHeaderBarFlag } = useFeatureValue('adminHeaderBarEnabled');
  const isAdminHeaderBarEnabled = adminHeaderBarFlag === 'on';

  const onBackClick = () => {
    const searchParams = new URLSearchParams(location.search);
    const ref = searchParams.get('ref');

    if (ref) {
      withWindow(() => {
        window.location.href = `${window.location.origin}${decodeURIComponent(ref)}`;
      });

      return;
    }

    routerHelper.goToAdminRoute(ecardDraftType);
  };

  const ecardTypeDisplayName = getEcardTypeDisplayName(ecardDraftType);

  return (
    <EcardContainer
      alignItems="flex-start"
      justifyContent="center"
    >
      {isAdminHeaderBarEnabled ? (
        <>
          <AdminHeaderBar
            title={ecardTypeDisplayName}
            hideHamburger={isNative}
            nativePadding={isNative}
            hideLogo={isMobile}
            onTitleClick={onBackClick}
          />
          <AdminHeaderBarSpacer />
        </>
      ) : (
        <Header
          callback={onBackClick}
          title={ecardTypeDisplayName}
          toDashboard={false}
        />
      )}
      <EcardWrapper>{children}</EcardWrapper>
    </EcardContainer>
  );
};
